document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('[data-production-videos]');

    if (!sections.length) {
        return;
    }

    sections.forEach((section) => {
        const dialog = section.querySelector('[data-production-videos-dialog]');
        const stage = section.querySelector('[data-production-videos-stage]');

        if (!dialog || !stage || typeof dialog.showModal !== 'function') {
            return;
        }

        const indexLabel = section.querySelector('[data-production-videos-index]');
        const titleLabel = section.querySelector('[data-production-videos-title]');
        const closeButton = section.querySelector('[data-production-videos-close]');
        let opener = null;

        // Removing the player is what stops playback — an iframe keeps running
        // otherwise, and a <video> keeps its buffer.
        function clearStage() {
            while (stage.firstChild) {
                stage.removeChild(stage.firstChild);
            }
        }

        function createPlayer(trigger) {
            const source = trigger.dataset.videoSrc;
            const title = trigger.dataset.videoTitle || '';

            if (trigger.dataset.videoType === 'embed') {
                const frame = document.createElement('iframe');

                frame.className = 'production-videos__player';
                frame.src = source;
                frame.title = title;
                frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
                frame.allowFullscreen = true;
                frame.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');

                return frame;
            }

            const video = document.createElement('video');

            video.className = 'production-videos__player';
            video.src = source;
            video.controls = true;
            video.autoplay = true;
            video.playsInline = true;
            video.setAttribute('playsinline', '');

            if (trigger.dataset.videoPoster) {
                video.poster = trigger.dataset.videoPoster;
            }

            return video;
        }

        function open(trigger) {
            if (!trigger.dataset.videoSrc) {
                return;
            }

            clearStage();

            const player = createPlayer(trigger);

            stage.appendChild(player);

            if (indexLabel) {
                indexLabel.textContent = trigger.dataset.videoIndex || '';
            }

            if (titleLabel) {
                titleLabel.textContent = trigger.dataset.videoTitle || '';
            }

            opener = trigger;
            document.body.style.overflow = 'hidden';
            dialog.showModal();

            if (typeof player.play === 'function') {
                const started = player.play();

                if (started && started.catch) {
                    // Autoplay with sound is blocked in some browsers — the
                    // controls are already there for the user to start it.
                    started.catch(() => {});
                }
            }
        }

        section.querySelectorAll('[data-production-video]').forEach((trigger) => {
            trigger.addEventListener('click', () => {
                open(trigger);
            });
        });

        if (closeButton) {
            closeButton.addEventListener('click', () => {
                dialog.close();
            });
        }

        // A click landing on the dialog itself came from the backdrop or the
        // padding around the panel, never from the panel.
        dialog.addEventListener('click', (event) => {
            if (event.target === dialog) {
                dialog.close();
            }
        });

        dialog.addEventListener('close', () => {
            clearStage();
            document.body.style.overflow = '';

            if (opener) {
                opener.focus();
                opener = null;
            }
        });
    });
});
